import { Optional } from '@mews/std';
import { MewsAvatar } from '@optimus-web/core';
import { MewsProfileAvatarProps } from '../../types';

export interface IntegrationProfileAvatarProps extends MewsProfileAvatarProps {
    originalSender: Optional<string>;
}

const IntegrationProfileAvatar = ({
    originalSender,
    notification,
    emblem,
    ...other
}: IntegrationProfileAvatarProps) => {
    if (!originalSender) return null;

    return <MewsAvatar alt={originalSender} title={originalSender} src="" {...other} />;
};

export default IntegrationProfileAvatar;
